import { useState, useEffect } from "react";
import {
  loadWarehouseList,
  loadWarehousListByStatus,
} from "../../services/warehouseService";

const useWarehouseList = (status, Mode) => {
  const [warehouseDetailList, setWarehouseDetailList] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [selectedWarehouseID, setSelectedWarehouseID] = useState(null);
  const [isWarehouseDataLoaded, setIsWarehouseDataLoaded] = useState(false);

  const fetchWarehouseList = async (selectedID = null) => {
    try {
      let data = [];

      // 🔹 Step 1: Try to load by status (active/inactive)
      if (status !== null) {
        const para = {
          p_company_id: localStorage.getItem("companyid"),
          p_plant_id: 1,
          p_status: status,
        };
        data = await loadWarehousListByStatus(para);
      } else {
        data = await loadWarehouseList({
          p_companyid: localStorage.getItem("companyid"),
        });
      }

      // 🔹 Step 2: Fallback — if no active found, load all
      if ((!data || data.length === 0) && status === true && selectedID) {
        data = await loadWarehouseList({
          p_companyid: localStorage.getItem("companyid"),
        });
      }

      // 🔹 Step 3: Process list and handle inactive selected
      if (data && data.length > 0) {
        let updatedList = [...data];
        let initialWarehouse = data.find((t) => t.warehouse_id === selectedID);

        if (!initialWarehouse && selectedID) {
          const allData = await loadWarehouseList({
            p_companyid: localStorage.getItem("companyid"),
          });
          const inactiveWarehouse = allData.find(
            (t) => t.warehouse_id === selectedID
          );
          if (inactiveWarehouse) {
            updatedList.push(inactiveWarehouse);
            initialWarehouse = inactiveWarehouse;
          }
        }

        setWarehouseDetailList(updatedList);
        if (initialWarehouse) {
          setSelectedWarehouse(initialWarehouse);
          setSelectedWarehouseID(initialWarehouse.warehouse_id);
        }

        setIsWarehouseDataLoaded(true);
      } else {
        // 🔹 Step 4: If no data found at all
        setSelectedWarehouse(null);
        setSelectedWarehouseID(null);
        setWarehouseDetailList([]);
        setIsWarehouseDataLoaded(true);
      }
    } catch (error) {
      console.error("Error fetching warehouses:", error);
    }
  };

  // 🔹 Load on mount
  useEffect(() => {
    if (!isWarehouseDataLoaded) {
      fetchWarehouseList();
    }
  }, [isWarehouseDataLoaded]);

  // 🔹 Load by selected ID
  const loadWarehouseByID = async (selectedID) => {
    await fetchWarehouseList(selectedID);
  };

  return {
    warehouseDetailList,
    selectedWarehouse,
    selectedWarehouseID,
    setSelectedWarehouse,
    setSelectedWarehouseID,
    setIsWarehouseDataLoaded,
    loadWarehouseByID,
  };
};

export default useWarehouseList;
